module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"label":"AIがおすすめするサイズを確認してみてください"}}')
  delete Component.options._Ctor
}
